import React, { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import { Button, Container, Row, Col, Image } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { MessageDetailsAction } from '../../../Redux/Inbound/actions';
import moment from 'moment';


export default function ContactMessage({ show, handleClose, data }) {
  const dispatch = useDispatch();
  const messageDetails = useSelector(state => state.inboundReducer.MessageDetails)
  let id = data?.map(item => item.messageID) ?? [];
  const user = useSelector((state) => state.authReducer?.data);

  useEffect(() => {
    async function fetchData() {
      if (id[0]) {
        await MessageDetailsAction(dispatch, id, user?.accountID);
      }
    }
    fetchData();
  }, [id[0]])


  let initials;
  let formattedDateTime;
  if (data && Object.keys(data).length !== 0) {
    const getInitials = (fullName, firstName, lastName) => {
      if (fullName) {
        return fullName.split(' ').map(name => name.charAt(0)).join('').toUpperCase();
      } else if (firstName && lastName) {
        return `${firstName[0]}${lastName[0]}`.toUpperCase();
      } else {
        return "";
      }
    };

    initials = getInitials(messageDetails?.messageData?.name, messageDetails?.messageData?.firstName, messageDetails?.messageData?.lastName).slice(0, 2);
    formattedDateTime = moment(messageDetails?.createdAt).format('YYYY-MM-DD HH:mm:ss A');
  }

  return (
    <>
      {(messageDetails && Object.keys(messageDetails).length !== 0) ?
        <Container>
          <Modal show={show} onHide={handleClose} scrollable>

            <Modal.Body>
              <strong>Inbox message</strong>
              <Row className=" d-flex align-items-center mt-3 w-100 ml-0" >
                <Col md={2} className=''>
                  {/* <small className='custom-bg-messageSection-top ml-4'>{initials}</small> */}
                  <Image
                    src={`https://ui-avatars.com/api/?name=${initials}&background=172e57&color=fff&size=40`}
                    roundedCircle
                    className='custom-avatar'
                  />
                </Col>
                <Col className='d-flex flex-column p-0'>
                  <p className='message-ptag'>
                    {messageDetails?.messageData?.name
                      ? messageDetails.messageData?.name
                      : messageDetails?.messageData?.firstName && messageDetails?.messageData?.lastName
                        ? `${messageDetails.messageData?.firstName} ${messageDetails.messageData?.lastName}`
                        : "No Name"}
                  </p>
                  {/* <p >Dacula, Geogia</p> */}
                </Col>
              </Row>
              <Row className='mt-5 d-flex'>
                <Col md={5} className='p-0 text-center' ><p className='date-small'>From +{messageDetails?.callerNumber}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>To +{messageDetails?.callTo}</p></Col>
              </Row>
              <Row className='d-flex ml-0'>
                <Col md={5} className='p-0 text-center'><p className='date-small'>Answered by {messageDetails?.answeredBy}</p></Col>
                <Col md={1} className='p-0 text-center'>-</Col>
                <Col md={6} className='p-0 text-center'><p className='date-small'>{formattedDateTime}</p></Col>
              </Row>
              {messageDetails ? <>
                <Row className='mt-4 d-flex flex-column ml-2'>
                  {Object?.entries(messageDetails?.messageData).map(([key, value]) => (
                    key !== "id" && (
                      <Container key={key} className='mt-2 mb-3'>
                        <div className='mb-1'>
                          <strong className='message-p-tag'>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>
                        </div>
                        <div>
                          {value}
                        </div>
                      </Container>
                    )
                  ))}
                </Row></>
                : ''}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" className='custom-button' onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
        :
        <div className='d-flex justify-content-center align-items-center my-5 '>
          <h5 className='custom-color-grey my-5'>Nothing to show</h5>
        </div>}
    </>
  )
}
